import { Button as BtnAntd, Modal as ModalBtn, Table as TableAntd } from 'antd';
import styled from 'styled-components';

export const Table = styled(TableAntd)`
  table th {
    padding: 0 !important;
    .ant-table-filter-column {
      padding: 0px;
    }
  }

  tbody > tr {
    cursor: pointer;
  }

  .ant-table-thead > tr > th .ant-table-column-sorters {
    position: relative;
  }

  .ant-table-thead > tr > th .ant-table-column-sorters > span:first-child {
    white-space: nowrap;
  }

  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    font-size: 12px;
    padding: 5px;
  }
  .ant-table-row-level-1 {
    .indent-level-1,
    .indent-level-0 {
      display: none;
    }
  }
  .ant-table-row-level-0 {
    .ant-table-row-spaced {
      display: none;
    }
  }
  .td-origem-destino {
    .click-modal {
      color: #000000a6;
      &:hover {
        text-decoration: underline;
        color: #000;
      }
    }
  }
  .td-placa {
    &:hover {
      span {
        color: #449d44;
      }
    }
  }
  table tr:nth-child(odd) td {
    background-color: #fafafa;
  }
`;

export const Texto = styled.span`
  display: block;
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BtnDownloadCTE = styled(BtnAntd)`
  &,
  &:focus,
  &:active {
    color: #fff;
    background-color: #87ce50;
    border-color: #87ce50;
  }

  &:hover {
    background-color: #90da56;
    border-color: #90da56;
    color: #fff;
  }

  &:disabled {
    background-color: #c9ecad;
    border-color: #c9ecad;
  }
`;

export const ModalPlaca = styled(ModalBtn)`
  .ant-modal-header {
    border-bottom: 0;
    .ant-modal-title {
      font-size: 28px;
      font-weight: 300;
      color: #676a6c;
      padding: 10px;
    }
  }
  .ant-modal-footer {
    border-top: 0;
    .ant-btn-primary {
      background: #449d44;
      border-color: #449d44;
    }
  }
`;
